import { render, staticRenderFns } from "./DsReturn.vue?vue&type=template&id=ed484c46"
import script from "./DsReturn.vue?vue&type=script&lang=js"
export * from "./DsReturn.vue?vue&type=script&lang=js"
import style0 from "./DsReturn.vue?vue&type=style&index=0&id=ed484c46&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports